// Leadership supplied by the owner; shared with the Nepal team's approved copy.
export const TEAM = [
  { name: 'Sujan Acharya', role: 'Chief Executive Officer', initials: 'SA', responsibility: 'Leads the company and the product.' },
  { name: 'Subrat Acharya', role: 'Chief Financial Officer', initials: 'SA', responsibility: 'Responsible for finance and operations.' },
  { name: 'Rhythm Bhattarai', role: 'Chief Technology Officer', initials: 'RB', responsibility: 'Responsible for engineering and the planning engine.' },
];
